import { PropertyGroup } from '@features/product/typings';

export default function countTotalProperties(propertyGroups: PropertyGroup[]): number {
  const propertiesLength = propertyGroups.reduce((acc, propertyGroup) => {
    return acc + propertyGroup.properties.length;
  }, 0);

  return propertiesLength;
}
